import { render, staticRenderFns } from "./TestPackageIndex.vue?vue&type=template&id=1ce9e148"
import script from "./TestPackageIndex.vue?vue&type=script&lang=js"
export * from "./TestPackageIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports